<template>
    <div id="calendar-list">
        <div class="calendar-actions">
            <div class="my-calendars-title" @click="() => (calendarListVisible = !calendarListVisible)">
                <span class="title">{{ $t("calendar.calendars") }}</span>
                <span class="material-icons" v-if="calendarListVisible">expand_less</span>
                <span class="material-icons" v-else>expand_more</span>
            </div>
            <a-tooltip placement="right" :title="$t('calendar.newCalendar')" @click="() => openNewCalendarModal()">
                <span class="material-icons" style="font-size: 20px; cursor: pointer">add</span>
            </a-tooltip>
        </div>
        <div class="my-calendars-list" v-if="calendarListVisible">
            <div v-for="calendarUserGroup in calendarUserGroups">
                <div class="user-info" @click="() => (calendarUserGroup.visible = !calendarUserGroup.visible)">
                    <span class="material-icons" v-if="calendarUserGroup.visible">expand_less</span>
                    <span class="material-icons" v-else>expand_more</span>
                    <span>{{ calendarUserGroup.userId.name }}</span>
                </div>
                <div
                    v-if="calendarUserGroup.visible"
                    v-for="calendar in getUserCalendarList(calendarUserGroup.userId._id)"
                    class="my-calendars-item"
                >
                    <div class="box" @click="$emit('selectCalendar', calendar)">
                        <div
                            class="material-icons checkbox-btn"
                            v-if="isSelected(calendar)"
                            :style="{ color: calendar.color }"
                        >
                            check_box
                        </div>
                        <div class="material-icons checkbox-btn" v-else>check_box_outline_blank</div>
                        <span class="name">{{ calendar.summary }}</span>
                    </div>
                    <a-popover trigger="click" placement="right" v-if="isPermission(calendar)">
                        <template #content class="color-template">
                            <a-popover trigger="click">
                                <template #content>
                                    <div style="display: flex; flex-direction: row; align-items: center">
                                        <a-input
                                            id="calendarColor"
                                            v-model="calendar.color"
                                            class="color-input"
                                            type="color"
                                        />
                                        <div class="change-color" @click="updateCalendarColor(calendar)">
                                            {{ $t("calendar.change") }}
                                        </div>
                                    </div>
                                </template>
                                <div style="cursor: pointer">{{ $t("calendar.changeColor") }}</div>
                            </a-popover>
                            <div
                                @click="deleteCalendar(calendar._id)"
                                v-if="isDeletePermission(calendar)"
                                class="popover-btn"
                            >
                                Sil
                            </div>
                        </template>
                        <span class="material-icons" style="font-size: 20px; cursor: pointer">more_vert</span>
                    </a-popover>
                </div>
            </div>
        </div>
        <a-modal
            :visible="newCalendarModalVisible"
            :cancelText="$t('calendar.cancel')"
            :okText="$t('calendar.save')"
            centered
            @cancel="newCalendarModalVisible = false"
            :footer="null"
        >
            <div class="modal-container">
                <div class="add-calendar-title">{{ $t("calendar.addCalendar") }}</div>
                <input
                    type="text"
                    class="event-input"
                    :placeholder="$t('calendar.nameCalendar')"
                    v-model="newCalendarSummary"
                />
                <input
                    type="text"
                    class="event-input"
                    :placeholder="$t('calendar.description')"
                    v-model="newCalendarDescription"
                />
            </div>
            <div class="footer-action">
                <span class="footer-action-btn" @click="closeCreateCalendarModal">{{ $t("calendar.cancel") }}</span>
                <span class="footer-action-btn" @click="createCalendar()">{{ $t("calendar.save") }}</span>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../../utils/log2";
import _ from "lodash";
import { i18n } from "../../../../language";
import { PERMISSION_TYPES } from "../../../../language/permissionTypes";

const log = log2("CalendarList");
export default {
    name: "CalendarList",
    components: {},
    props: {
        calendarList: {
            type: Array,
            default: () => [],
        },
        selectedCalendars: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            calendarListVisible: true,
            newCalendarModalVisible: false,
            newCalendarSummary: "",
            newCalendarDescription: "",
            calendarUserGroups: [],
            selectedColor: "",
            cloneCalendarList: _.cloneDeep(this.calendarList),
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        ...mapActions({
            createCalendarAction: "calendar/createCalendar",
            getAllUsers: "user/getUsers",
            deleteCalendarAction: "calendar/deleteCalendar",
        }),
        ...mapMutations({}),
        openNewCalendarModal() {
            if (this.checkPermission(PERMISSION_TYPES["calendar.create"].tr.name)) {
                this.newCalendarModalVisible = true;
            } else {
                this.$message.error(this.$t("noPermission"));
            }
        },
        isPermission(calendar) {
            console.log("isPermission calendar", calendar);
            return calendar.userId._id === this.user._id;
        },
        isDeletePermission(calendar) {
            return !calendar.isDefault && calendar.type === "supsis";
        },
        deleteCalendar(calendarId) {
            this.$confirm({
                title: this.$t("calendar.deleteCalendar"),
                content: this.$t("calendar.deleteCalendarSure"),
                okText: this.$t("calendar.yes"),
                okType: "danger",
                cancelText: this.$t("calendar.no"),
                onOk: () => {
                    const prop = {
                        title: i18n.messages[`${i18n.locale}`].calendar.deleteEvents,
                        content: i18n.messages[`${i18n.locale}`].calendar.deleteEventsSure,
                        okText: i18n.messages[`${i18n.locale}`].calendar.yes,
                        okType: "danger",
                        cancelText: i18n.messages[`${i18n.locale}`].calendar.no,
                    };
                    this.$confirm({
                        ...prop,
                        onOk: () => {
                            this.deleteCalendarAction({ userId: this.user._id, calendarId, isDeleteEvents: true });
                            this.cloneCalendarList = this.cloneCalendarList.filter(
                                (calendar) => calendar._id !== calendarId
                            );
                            this.$emit("deleteCalendarEvents", calendarId);
                        },
                        onCancel: () => {
                            this.deleteCalendarAction({ userId: this.user._id, calendarId, isDeleteEvents: false });
                            this.cloneCalendarList = this.cloneCalendarList.filter(
                                (calendar) => calendar._id !== calendarId
                            );
                        },
                    });
                },
            });
        },
        getUserCalendarList(userId) {
            return this.cloneCalendarList.filter((calendar) => calendar.userId._id === userId);
        },
        createCalendar() {
            if (!this.newCalendarSummary) return this.$message.error(this.$t("calendar.notEmptyCalendarName"));
            this.createCalendarAction({
                userId: this.user._id,
                payload: {
                    summary: this.newCalendarSummary,
                    description: this.newCalendarDescription,
                },
            }).then((res) => {
                this.newCalendarModalVisible = false;
                this.newCalendarSummary = "";
                this.newCalendarDescription = "";
                res.userId = { _id: this.user._id, name: this.user.name };
                this.cloneCalendarList = [...this.cloneCalendarList, res];
                this.getUserGroup();
            });
        },
        closeCreateCalendarModal() {
            this.newCalendarModalVisible = false;
            this.newCalendarSummary = "";
            this.newCalendarDescription = "";
        },
        async updateCalendarColor(calendar) {
            this.$emit("updateCalendarColor", {
                calendarId: calendar._id,
                color: calendar.color,
            });
        },
        isSelected(calendar) {
            return this.selectedCalendars.includes(calendar._id);
        },
        getUserGroup() {
            const userGroups = _.uniqBy(this.cloneCalendarList, "userId._id");
            const otherGroups = userGroups.filter((group) => group.userId._id !== this.user._id);
            const userGroup = userGroups.filter((group) => group.userId._id === this.user._id);
            this.calendarUserGroups = _.flatten([...userGroup, ...otherGroups]);
            this.calendarUserGroups = this.calendarUserGroups.map((group) => {
                if (group.userId._id === this.user._id) {
                    return {
                        ...group,
                        visible: true,
                    };
                }
                return {
                    ...group,
                    visible: false,
                };
            });
        },
    },
    async mounted() {
        this.getUserGroup();
    },
    watch: {
        calendarList(val) {
            this.cloneCalendarList = _.cloneDeep(val);
            this.getUserGroup();
        },
    },
};
</script>

<style lang="scss">
.ant-popover-inner-content {
    padding: 5px;
}
</style>

<style lang="scss" scoped>
.popover-btn {
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
    margin: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 500;

    &:hover {
        background-color: #f3f3f3;
    }
}

.footer-action-btn {
    padding: 7px 10px;
    border-radius: 5px;
    background-color: #4285f4;
    color: white;
    margin-top: 10px;
}

.add-calendar-title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 10px;
}

.color-input {
    margin: 5px 0;
    width: 130px;
    height: 120px;
}

.change-color {
    cursor: pointer;
    background-color: #dcdbdb;
    padding: 3px;
    width: fit-content;
    border-radius: 5px;
    height: fit-content;
    margin-left: 5px;
}

.color-template {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 10px;
}

.modal-container {
    width: 95%;

    .event-input {
        width: 100%;
        border: none;
        border-bottom: 0.5px solid grey;
        margin-bottom: 10px;
        height: 30px;
        margin-top: 10px;

        &:hover {
            border-bottom: 1px solid #021eb6;
        }
    }

    .tags {
        display: flex;
        align-items: center;

        .tag {
            color: rgb(109, 117, 131);
            padding: 5px;
            border-radius: 5px;
            font-size: 12px;
            font-weight: 500;
            margin-right: 10px;
            cursor: pointer;

            &:hover {
                background-color: #e8e8e8;
            }

            &.selected {
                background-color: rgb(210, 227, 252);
                color: rgb(66, 133, 244);
            }
        }
    }

    .single {
        margin-right: 5px;
    }

    .info {
        margin-top: 15px;
        display: flex;
        align-items: center;
    }

    .attachments {
        .attachment {
            margin-bottom: 5px;
            background-color: aliceblue;
            padding: 3px;
            border-radius: 5px;
        }
    }

    .description {
        margin-left: 10px;
    }

    .attach-icon {
        font-size: 20px;
    }

    .attachment {
        display: flex;
        align-items: center;
    }

    .lock-icon {
        font-size: 20px;
        margin-right: 10px;
    }

    .attache_file_btn {
        border: none;
        padding: 5px;
        border-radius: 5px;
        background-color: white;

        &:hover {
            background-color: #e8e8e8 !important;
        }
    }
}

#calendar-list {
    .calendar-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .my-calendars-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;
            cursor: pointer;
            width: 60%;

            .title {
                font-weight: 700;
                font-size: 17px;
            }
        }
    }

    .my-calendars-list {
        .user-info {
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            cursor: pointer;
            font-weight: 500;
            font-size: 15px;

            &:hover {
                background-color: #f3f3f3;
                border-radius: 5px;
            }
        }

        .my-calendars-item {
            display: flex;
            align-items: center;
            margin-bottom: 3px;
            cursor: pointer;
            justify-content: space-between;
            margin-left: 10px;

            .checkbox-btn {
                font-size: 20px;
            }

            .box {
                display: flex;
                align-items: center;
                justify-content: center;

                .name {
                    font-size: 13px;
                    font-weight: 500;
                    width: 150px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 3px;

                    &:hover {
                        background-color: #f3f3f3;
                        border-radius: 5px;
                    }
                }
            }
        }
    }
}
</style>
